import { atom } from 'recoil';

export const studentPagination = atom({
  key: 'studentPagination',
  default: 1,
});
